import { Type } from 'class-transformer';
import { BaseEntity } from '@models';
import { Organization } from '../organization';

export class DealerConfig extends BaseEntity {
	organizationId: string;

	@Type(() => Organization)
	organization: Organization;

	isOpenToB2C?: boolean;
	isVehiclePriceVisible?: boolean;
	isPackageDealPriceVisible?: boolean;
	dieselPrice?: number;
	gasolinePrice?: number;
	gplPrice?: number;
	naturalGasPrice?: number;
	electricityPrice: number;
	electricityHomePrice?: number;
	electricitySolarPrice?: number;
}
